import { get } from '@classic/Foundation/Services/ApiService'
import { CognitoUser } from '@mobi/api-types'
import { QueryClient, useQuery } from '@tanstack/react-query'

let lastUsedAccountNumber: number | undefined

export function cognitoUserQueryKey(accountNumber?: number) {
  return ['cognitoUser', accountNumber ?? lastUsedAccountNumber]
}

export function invalidateCognitoUserQuery(queryClient: QueryClient, accountNumber?: number) {
  queryClient.invalidateQueries({ queryKey: cognitoUserQueryKey(accountNumber) })
}

export function useCognitoUser(accountNumber: number) {
  lastUsedAccountNumber = accountNumber
  return useQuery<CognitoUser>({
    queryKey: cognitoUserQueryKey(accountNumber),
    queryFn: () =>
      get<CognitoUser>({
        url: '/api/mfa/get-auth-contact-details',
      }),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  })
}
